'use strict';

function controller($scope, $element) {

    // Sets the `amount` based on the first option
    $scope.amount = $element.find('input[type="radio"]').first().val();
}

module.exports = [
    '$scope',
    '$element',
    controller,
];



// WEBPACK FOOTER //
// ./widgets/controllers/QuickGive.js